import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const ScrollToAnchor = (): any => {
  const location = useLocation();

  useEffect(() => {
    const href = window.location.href;
    const hashIndex = href.indexOf('#');

    if (hashIndex !== -1 && hashIndex < href.length - 1) {
      const id = href.substring(hashIndex + 1);

      const scrollToElement = (): any => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({behavior: 'smooth'});
        }
      };

      setTimeout(scrollToElement, 100);
    }
  }, [location]);

  return null;
};